<template>
  <div
    class="o-object-profile__full-bleed-wrapper--loading o-object-profile__full-bleed-wrapper"
  ></div>
</template>
<script>
export default {
  name: "LoadingProfile"
};
</script>
